/* src/app/components/submission-model-group-characteristics-eu/submission-model-group-characteristics-eu.component.css */
/*# sourceMappingURL=submission-model-group-characteristics-eu.component.css.map */
